











import _ from "lodash";
import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { User } from "front-component/modules/User";
import EventBus from "front-component/EventBus";
import Login from "@/components/Login.vue";

const components = {
    Login,
};

@Component({ components })
export default class Page extends Vue {
    @Getter("getCurrentUser") public currentUser!: User|null;

    public get requiresAuth(): boolean {
        return _.get(this.$route, "meta.requiresAuth", true);
    }

    public detectedScroll(event: any): void {
        if (!(event.target.scrollHeight - event.target.clientHeight - event.target.scrollTop)) {
            EventBus.$emit("endScrolling");
        }
    }
}
